import { useStepState } from 'src/app/pages/startAPetition/pageContext';

import { SkipStep } from '../../SkipStep';

import { AIResultsDraftLoader } from './AIResultsDraftLoader';

export function AIResultsDraftWrapper(): React.JSX.Element {
	const { data } = useStepState();
	const isSkipped = data.petition?.aiPromptChoice !== 'ai';

	return isSkipped ? <SkipStep /> : <AIResultsDraftLoader />;
}
